
import { DollarSign } from "lucide-react";
import { Investment } from "@/types/investment";
import { formatCurrency } from "./utils";

interface InvestmentOpportunityProps {
  investment: Investment;
}

const InvestmentOpportunity = ({ investment }: InvestmentOpportunityProps) => {
  return (
    <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200 mb-6">
      <h4 className="text-lg font-semibold text-yellow-800 mb-4 flex items-center">
        <DollarSign className="h-5 w-5 mr-2" />
        Investment Opportunity
      </h4>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <div className="flex justify-between mb-2">
            <span className="text-sm text-gray-600">Asking Price:</span>
            <span className="text-xl font-bold text-gray-900">
              {investment.askingPrice ? formatCurrency(investment.askingPrice) : 'Contact for Price'}
            </span>
          </div>
          <div className="flex justify-between mb-4">
            <span className="text-sm text-gray-600">Minimum Bid:</span>
            <span className="font-semibold">{formatCurrency(investment.minimumBid)}</span>
          </div>
        </div>
        <div className="text-center">
          <div className="text-3xl font-bold text-yellow-800 mb-1">
            {investment.yield}%
          </div>
          <div className="text-sm text-gray-600">Annual Yield</div>
        </div>
      </div>
    </div>
  );
};

export default InvestmentOpportunity;
